<script setup>
import { ref, watch } from 'vue'
import { blogService } from '@/http'
import { useRoute, useRouter } from 'vue-router'

import ThumbCover from '@/Components/ThumbCover.vue'
import Comment from '@/Modals/Comment.vue'
import Report from '@/Modals/Report.vue'

import { timeAgo } from '@/Utils/date'

const route = useRoute()
const router = useRouter()


const item = ref({
    id: ''
})

const relatedes = ref([])

const getRelated = () => {
    blogService.index({
        id: route.params.id
    }).then(res => {
        relatedes.value =  res.data.items
    })
}


const formatDate = (isoString) => {
    if(!isoString) return '';
    const date = new Date(isoString);

    const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    };

    // Use Intl.DateTimeFormat for consistent formatting
    const formatter = new Intl.DateTimeFormat('en-US', options);
    const parts = formatter.formatToParts(date);

    const month = parts.find(part => part.type === 'month').value;
    const day = parts.find(part => part.type === 'day').value;
    const year = parts.find(part => part.type === 'year').value;
    const hour = parts.find(part => part.type === 'hour').value;
    const minute = parts.find(part => part.type === 'minute').value;

    return `${month}.${day}.${year} ${hour}:${minute}`;
}



const fetchData = () => {
    blogService.get({id: route.params.id}).then(res => {
        item.value = res.data
    })
}

watch(
  () => route.params,
  async () => {
    fetchData()
    getRelated()
  },
  {
    flush: 'post',
    immediate: true
  }
)

</script>
<template>
<div class="blog-page">
    <article class="blog">
        <div class="blog__moderated" v-if="item.deleted_at">
            Ваш пост находиться на модерации ⌛️
        </div>
        <template v-if="item.title">
            <ThumbCover class="blog__img" :item="item" />
            <h1 class="blog__title">{{ item.title }}</h1>

            <div class="blog__meta thumb-user">
                <Link tag="div" class="thumb-user__photo" :to="{ name: 'user', params: { user: item.user.id } }">
                    <img v-if="item.user.photo" :src="item.user.photo" alt="" />
                    <Icon v-else name="face-smile" />
                </Link>
                
                <Link tag="div" class="thumb-user__info" :to="{ name: 'user', params: { user: item.user.id } }">
                    <span class="thumb-user__name">{{ item.user.name }}</span>
                    <span class="thumb-user__date">{{ timeAgo(item.created_at) }}</span>
                </Link>

                <div class="thumb-user__btn" @click="$modal.show('plus')">
                    <Modal className="thumb-user__report" title="Жалоба" :auth="true">
                        <Icon name="flag" />
                        <template #content>
                            <Report type="blog" :id="item.id" />
                        </template>
                    </Modal>
                </div>
            </div>

            <div class="blog__text" v-html="item.html"></div>
            <div class="blog__moderated" v-if="item.deleted_at">
                Ваш пост находиться на модерации ⌛️
            </div>
        </template>
    </article>
    <div class="relateds">
        <router-link
            v-for="related in relatedes"
            class="related"
            :key="related.id"
            :to="{
                name: 'blog',
                params: {
                    id: related.id
                }
            }"
        >
            <figure class="related__img">
                <img 
                    :src="$root.$pixel"
                    v-lazy="related.image"
                    :alt="related.title"
                />
            </figure>
            <span class="related__title">{{ related.title }}</span>
        </router-link>
    </div>
    <div class="comments">
        <h2 class="comments__title">Комментарии</h2>
        
        <div class="comment" v-for="(comment, index) in item.comments" :key="index">
            <span>{{ comment.name }}</span>
            <div>{{ comment.comment }}</div>
            <Modal className="comment__report" title="Жалоба" :auth="true">
                <Icon name="flag" />
                <template #content>
                    <Report type="comment" :id="item.id + '0' + index" />
                </template>
            </Modal>
        </div>
    </div>

    <Modal className="plus" title="Добавить" :auth="true">
        <Icon name="comment-plus" />
        <template #content>
         <Comment />
        </template>
    </Modal>

</div>
</template>



<style lang="scss">
.join {
  display: grid;
  grid-template-columns: 40px 1fr;
  gap: 0 10px;
  line-height: 1;
  cursor: pointer;

  &__photo {
    display: flex;
    align-items: center;
    font-size: 35px;
    justify-content: center;
    height: 40px;

    img {
      object-fit: cover;
      height: 100%;
      width: 100%;
      border-radius: 50%;
    }
  }

  &__info {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  &__name {
    font-weight: bold;
  }
}
.relateds {
    width: 100%;
    display: flex;
    gap: 10px;
    overflow-x: scroll;
    white-space: nowrap;
    margin-top: 20px;
    scrollbar-width: none;

    &::-webkit-scrollbar {
        display: none;
    }
}

.related {
    width: 150px;
    flex-shrink: 0;
    &__img {
        aspect-ratio: 1 / 1;
        img {
            border-radius: 8px;
            object-fit: cover;
            width: 100%;
            height: 100%;
        }
    }
    &__title {
        margin-top: 5px;
        display: block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}

// input {
//     background: #FFF;
//     border-radius: 8px;
//     padding: 0 10px;
//     height: 36px;
//     border: 1px solid #333;
//     width: 100%;
//     max-width: 250px;
// }
.comments {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 30px;

    &__form {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    &__moder {
        margin-top: 5px;
        background: #925fd6;
        border-radius: 8px;
        color: #FFF;
        padding: 8px;
        width: fit-content;
        margin: 100px auto;
    }
}
.comment {
    position: relative;
    span {
        font-weight: bold;
    }
    div {
        margin-top: 2px;
        background: #f2f2f2;
        border-radius: 8px;
        padding: 8px;
        width: fit-content;
    }
    &__report {
        position: absolute;
        top: 0;
        right: 5px;
    }
}
.blog {
    display: flex;
    flex-direction: column;
    gap: 15px;
    min-height: 100vh;

    @include mq('md') {
        background: var(--background);
        padding: 15px;
        box-shadow: 0 0 #0000, 0 0 #0000, 0 0 1px rgba(28, 41, 61, .08);
        border-radius: 6px;
    }

    &__moderated {
        background: var(--background-primary);
        padding: 10px;
        border-radius: 8px;
        color: var(--color-text);
        text-align: center;
    }

    &__header {
        display: flex;
        align-items: center;
    }

    &__address {
        font-weight: bold;
        line-height: 1;
        display: flex;
        align-items: center;
        gap: 5px;
    }

    &__join {
        background: var(--color-gradient);
        padding: 15px 0;
        border-radius: 6px;
        color: #FFF;
        font-weight: bold;
    }

    &__joined {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    &__title {
        font-size: 22px;
        font-size: 1.6;

        @include mq('md') {
            font-size: 32px;
        }
    }

    &__meta {
        display: flex;
        gap: 10px;
        //font-weight: bold;

        span {
            display: inline-flex;
            gap: 5px;
            align-items: center;
        }
    }

    &__report {
        margin-left: auto;
        font-size: 24px;
    }

    // &__img {
    //     //aspect-ratio: 1 / 1;
    //     width: 100%;
    //     max-width: 420px;
    //     margin: 0 auto;

    //     img {
    //         border-radius: 10px;
    //     }
    // }
    &__text {
        font-size: 16px;
        line-height: 1.6;
        P {
            & + * {
                margin-top: 10px;
            }
        }
    }
}

.blog-page {
    &__nav {
        position: fixed;
        bottom: 60px;
        width: 100%;
        margin: 0 auto;
    }
}
</style>